var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mains"},[_c('div',{staticClass:"code-div"},[_c('canvas',{attrs:{"id":"msg"}}),_vm._v(" "),_c('p',[_vm._v("\n      微信扫码支付后，请耐心等待（还剩\n      "),_c('span',{staticClass:"red"},[_vm._v(_vm._s(60-_vm.t)+" s")]),_vm._v("）\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fde0628","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/zhifu.vue
// module id = null
// module chunks = 